import { ArrowBeakIcon } from '@hedepy/icons/refactor/ArrowBeak'
import { cva } from 'class-variance-authority'
import type { ChevronProps } from 'react-day-picker'

const chevronVariants = cva('', {
  variants: {
    orientation: {
      up: 'rotate-180',
      down: 'rotate-0',
      left: 'rotate-90',
      right: '-rotate-90',
    },
  },
  defaultVariants: {
    orientation: 'left',
  },
})

export type ClientBookingMonthCalendarChevronProps = ChevronProps

export const ClientBookingMonthCalendarChevron = ({ orientation }: ClientBookingMonthCalendarChevronProps) => (
  <ArrowBeakIcon aria-hidden size={24} className={chevronVariants({ orientation })} />
)
